class InstagramFeed extends HTMLElement {
    constructor() {
        super();
        this.urlInst = this.dataset.instagram;
        this.url = 'https://api.nfcube.com/feed/v6?limit=24&account=seriously-good-studio.myshopify.com&fu=0&fid=0&hash=2fcd1759226d7592afbeb8a172ddd986&locale=en&handle=&client=feed';
        this.RenderElement();
    }

    async RenderElement () {
        await fetch(this.url, 
        {
            method: "POST",
        }).then( res => res.json()).then((res) => {
            console.log(res);
            const post = res.data;
            console.log(post);
            this.createElements(post);
            
        }) 
    }

    createElements (elements) {
        elements.forEach( (el, i) => {
            const mediaItem = el.type === 'carousel' && el.carousel_media && el.carousel_media.length
                ? el.carousel_media[0]
                : el;

            const swiperSlide = document.createElement('div');
            swiperSlide.classList.add('swiper-slide');
            swiperSlide.style.setProperty('--i', i);
            const linkInstagram = document.createElement('a');
            linkInstagram.setAttribute('target','_blank');
            linkInstagram.href = el.link;
            const swiperSlideWrap = document.createElement('div');
            swiperSlideWrap.classList.add('swiper-slide__wrap');
            const imageDiv = document.createElement('div');
            imageDiv.classList.add('image');
            const imageWrap = document.createElement('div');
            imageWrap.classList.add('image__wrap');
            const mediaElement = this.createMediaElement(mediaItem);
            imageWrap.appendChild(mediaElement);
            imageWrap.appendChild(linkInstagram);
            imageDiv.appendChild(imageWrap);
            swiperSlideWrap.appendChild(imageDiv);
            swiperSlide.appendChild(swiperSlideWrap);

            this.querySelector('.swiper-wrapper').appendChild(swiperSlide);
        });

            const swiper = this.querySelector('custom-slider');
            swiper.update();
            this.observeVideos();
    }

    createMediaElement (mediaItem) {
        const isVideo = mediaItem.type === 'video' && mediaItem.videos?.standard_resolution?.url;

        if (!isVideo) {
            const imgElement = document.createElement('img');
            imgElement.src = mediaItem.images.standard_resolution.url;
            imgElement.loading = 'lazy';
            return imgElement;
        }

        const videoElement = document.createElement('video');
        videoElement.src = mediaItem.videos.standard_resolution.url;
        videoElement.poster = mediaItem.images?.standard_resolution?.url || '';
        videoElement.muted = true;
        videoElement.loop = true;
        videoElement.autoplay = true;
        videoElement.playsInline = true;
        videoElement.setAttribute('muted', '');
        videoElement.setAttribute('autoplay', '');
        videoElement.setAttribute('loop', '');
        videoElement.setAttribute('playsinline', '');
        videoElement.setAttribute('preload', 'auto');
        videoElement.play().catch(() => {});
        return videoElement;
    }

    observeVideos () {
        if (!this.videoObserver) {
            this.videoObserver = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.play().catch(() => {});
                    } else {
                        entry.target.pause();
                    }
                });
            }, { threshold: 0.5 });
        }

        this.querySelectorAll('video').forEach((video) => {
            this.videoObserver.observe(video);
        });
    }
}

customElements.define('instagram-feed', InstagramFeed);